import React, { useState } from 'react'
import { NavLink, Link } from 'react-router-dom'
import classNames from 'classnames'
import classes from './Header.module.css'
import gridClasses from '../../styles/grid.module.css'
import logo from '../../assets/images/white-logo.png'
import { ReactComponent as MenuIcon } from '../../assets/icons/menu.svg'
import { ReactComponent as SearchIcon } from '../../assets/icons/search.svg'
import { ReactComponent as CartIcon } from '../../assets/icons/cart.svg'
import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg'
import { useSelector } from 'react-redux'
import { userSelectors } from '../../redux/userSlice'

export const SignupButton = ({ className, to, children, ...props }) => (
    <Link
        to={to}
        className={classNames(classes.headerButton, className)}
        {...props}
    >
        {children}
    </Link>
)

export const HeaderLink = ({ className, to, children, ...props }) => (
    <NavLink
        className={classNames(classes.headerLink, className)}
        activeClassName={classes.headerLinkActive}
        to={to}
    >
        {children}
    </NavLink>
)

export const HeaderSearch = ({
    className,
    value,
    onChange,
    onTriggerSearch,
    ...props
}) => {
    const handleChange = event => {
        const {
            target: { value },
        } = event
        if (typeof onChange === 'function') onChange(value)
    }

    const handleSubmit = event => {
        event.preventDefault()
        if (typeof onTriggerSearch === 'function') {
            onTriggerSearch(value)
        }
    }

    const label = `What do you want to learn?`
    return (
        <form
            className={classNames(classes.headerSearch, className)}
            onSubmit={handleSubmit}
        >
            <input
                className={classes.headerSearchInput}
                value={value}
                placeholder={label}
                aria-label={label}
                onChange={handleChange}
                {...props}
            />
            <button type="submit" className={classes.headerSearchButton}>
                <SearchIcon className={classes.headerSearchButtonIcon} />
            </button>
        </form>
    )
}

export const Header = ({ className, largeLogo = false, ...props }) => {
    const [open, setOpen] = useState(false)
    const [search, setSearch] = useState('')
    const [searchVisible, setSearchVisible] = useState(false)

    const isLoggedIn = useSelector(userSelectors.isLoggedIn)

    return (
        <div className={classNames(classes.header, className)} {...props}>
            <div
                className={classNames(
                    gridClasses.container,
                    classes.headerContainer
                )}
            >
                <div className={classes.mobileActions}>
                    <button
                        className={classes.navToggle}
                        onClick={() => setOpen(true)}
                    >
                        <MenuIcon />
                    </button>
                    <button
                        className={classes.searchButton}
                        onClick={() => setSearchVisible(true)}
                    >
                        <SearchIcon />
                    </button>
                </div>
                <Link to="/" className={classNames(classes.headerBrand)}>
                    <img
                        alt="SME Upturn Logo"
                        src={logo}
                        className={classNames(
                            classes.headerBrandImage,
                            largeLogo && classes.headerBrandLargeImage
                        )}
                    />
                </Link>
                <div
                    className={classNames(
                        classes.mobileSearchItem,
                        searchVisible && classes.mobileSearchItemActive
                    )}
                >
                    <button
                        className={classes.closeButton}
                        onClick={() => setSearchVisible(false)}
                    >
                        <CloseIcon className={classes.closeIcon} />
                    </button>
                    <HeaderSearch value={search} onChange={setSearch} />
                </div>
                <div className={classes.mobileActions}>
                    <Link to="/app/cart" className={classes.cartLink}>
                        <CartIcon />
                    </Link>
                </div>
                <nav
                    className={classNames(
                        classes.headerLinks,
                        open && classes.linksOpen
                    )}
                >
                    <ul className={classes.headerLinkList}>
                        <li className={classes.headerLinkItem}>
                            <HeaderLink to="/app/browse/courses">
                                Courses
                            </HeaderLink>
                        </li>
                        <li className={classes.headerLinkItem}>
                            <HeaderLink to="/app/browse/classes">
                                Classes
                            </HeaderLink>
                        </li>
                        <li className={classes.headerLinkItem}>
                            <HeaderLink to="/about-us">About Us</HeaderLink>
                        </li>
                        <li className={classes.headerLinkItem}>
                            <HeaderLink to="/blog">Blog</HeaderLink>
                        </li>
                        <li className={classes.headerLinkItem}>
                            <HeaderLink to="/solo-preneur">
                                Solopreneur
                            </HeaderLink>
                        </li>
                        <li className={classes.headerLinkItem}>
                            <HeaderLink to="/business">For Business</HeaderLink>
                        </li>
                    </ul>
                    {isLoggedIn ? (
                        <div className={classes.authLinks}>
                            <SignupButton to="/app">
                                Go to Dashboard
                            </SignupButton>
                        </div>
                    ) : (
                        <div className={classes.authLinks}>
                            <HeaderLink to="/app/auth/sign-in">
                                Login
                            </HeaderLink>
                            <SignupButton to="/app/auth/sign-up">
                                Sign Up
                            </SignupButton>
                        </div>
                    )}
                </nav>
                <div
                    className={classNames(
                        classes.drawerBackground,
                        open && classes.backgroundActive
                    )}
                    onClick={() => setOpen(false)}
                />
            </div>
        </div>
    )
}
